import React, { useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

export default function ForgotPassword() {
  const { loginWithRedirect, isLoading, error: auth0Error } = useAuth0();
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      setError('Please enter your email address.');
      return;
    }
    setError('');
    try {
      // Trigger Auth0 password reset flow with pre-filled email
      await loginWithRedirect({
        screen_hint: 'reset',
        login_hint: email
      });
      setSent(true);
    } catch (err) {
      setError('Failed to send reset link. Please try again.');
    }
  };

  return (
    <div className="login-bg">
      <div className="login-container">
        <div className="login-brand">
          <h1>EternaVaults</h1>
          <p className="login-tagline">Legacy, Secured</p>
        </div>
        <form className="login-form" onSubmit={handleSubmit}>
          <h2>Forgot Password</h2>
          {sent ? (
            <div style={{ color: '#e2c89c', margin: '1.5rem 0' }}>
              If an account with that email exists, a reset link has been sent.
            </div>
          ) : (
            <>
              <label>Email</label>
              <input
                type="email"
                placeholder="you@email.com"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
                autoFocus
              />
              {(error || auth0Error) && <div className="login-error">{error || auth0Error.message}</div>}
              <button type="submit" disabled={isLoading}>
                {isLoading ? "Sending..." : "Send Reset Link"}
              </button>
            </>
          )}
          <div className="login-links">
            <a href="/login">Back to Login</a>
          </div>
        </form>
      </div>
    </div>
  );
}
